// Storefront widgets that used to ship as Sprockets store/all.js.
// Loaded by packs/store.js, not application, so checkout does not download PhotoSwipe.
import './photoswipe';
import './filters';
import './sorting';
import './variants';

//
// Products filtering by brand
//
document.addEventListener('change', function(event) {
  if (event.target.matches('#filter #brand')) {
    event.target.form.submit();
  }
});

//
// Filtering for model tables
//
function filterCarTypes() {
  var table = document.getElementById('car_types_filter');
  if (!table) return;

  var year = document.getElementById('year').value;
  var model = document.getElementById('model').value;
  var capacity = document.getElementById('capacity').value;
  var power = document.getElementById('power').value;

  // "1.6 L" and "55 KW" carry their unit in the option label, the row cells hold bare numbers.
  var ccm = parseFloat(capacity);
  if (ccm < 100) ccm = ccm * 1000; // liters to cubic centimeters
  var kw = power.split(' ')[0];

  table.querySelectorAll('tbody tr').forEach(function(row) {
    var matched = true;

    if (year !== '') {
      // "..." marks an open-ended production interval, so that side never rules the row out.
      var wanted = parseInt(year, 10);
      var from = row.querySelector('.from').textContent;
      var to = row.querySelector('.to').textContent;
      from = from === '...' ? wanted : parseInt(from, 10);
      to = to === '...' ? wanted : parseInt(to, 10);
      matched = from <= wanted && wanted <= to;
    }

    if (matched && model !== '') {
      matched = row.dataset.modelShortName === model;
    }

    if (matched && capacity !== '') {
      // Option labels are rounded to one decimal, so match the row within a 10% tolerance.
      var value = parseInt(row.querySelector('.ccm').textContent, 10);
      matched = value * 0.9 <= ccm && ccm <= value * 1.1;
    }

    if (matched && power !== '') {
      matched = row.querySelector('.power').textContent.trim() === kw;
    }

    row.style.display = matched ? '' : 'none';
  });
}

document.addEventListener('change', function(event) {
  if (event.target.matches('#year, #model, #capacity, #power')) filterCarTypes();
});

// Selects are pre-filled from query params, so the table needs filtering on arrival too.
document.addEventListener('turbo:load', filterCarTypes);

//
// Scroll to element
//
document.addEventListener('click', function(event) {
  var link = event.target.closest('.scroll');
  if (!link) return;

  var target = document.querySelector(link.getAttribute('href'));
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth' });
});

// add custom locationchange event
history.pushState = (function(f) {
  return function pushState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('custom:locationchange'));
    return ret;
  };
})(history.pushState);

history.replaceState = (function(f) {
  return function replaceState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('custom:locationchange'));
    return ret;
  };
})(history.replaceState);

window.addEventListener('popstate', function() {
  window.dispatchEvent(new Event('custom:locationchange'));
});
